// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get all tab blocks on the page
      ui.blocks = doms(".block.accordion");

      // Iterate over the blocks to bind to each
      for (var index = 0; index < ui.blocks.length; index++) {
        block.bind(ui.blocks[index]);
      }

      // Bind the handler to the key down event on the document
      document.addEventListener("keydown", block.keydown);

    },

    /**
     * Method to handle binding to the DOM elements.
     *
     * @method block.bind
     */
    bind: function(parent) {

      // Get the DOM element references
      var elements = doms(".accordion-button", parent);

      // Get the elements as an array
      elements = utils.convertNodeListToArray(elements);

      // Skip if there aren't any elements
      if (elements.length === 0) {
        return;
      }

      // Iterate over the elements
      for (var index = 0; index < elements.length; index++) {
        // Get the current element in the loop
        var element = elements[index];
        // Get the associated panel
        var panel = document.getElementById(element.getAttribute("aria-controls"));
        // Handle on click
        element.onclick = block.click;
        // Set the initial state on the buttons
        element.setAttribute("aria-expanded", "false");
        // Set the initial state on the panels
        panel.setAttribute("aria-expanded", "false");
      }

    },

    /**
     * Method to handle toggling the accordion open/closed.
     *
     * @method block.toggle
     */
    toggle: function(element) {

      // Get the toggled active state
      var active = element.getAttribute("aria-expanded") !== "true";
      // Get the associated panel
      var panel = document.getElementById(element.getAttribute("aria-controls"));

      // Set the state on the button
      element.setAttribute("aria-expanded", active ? "true" : "false");
      // Set the label on the button
      element.setAttribute(
        "aria-label",
        active ? element.dataset.labelClose : element.dataset.labelOpen
      );
      // Set the state on the panel
      panel.setAttribute("aria-expanded", active ? "true" : "false");

    },

    /**
     * Method to handle clicking on the elements.
     *
     * @method block.click
     */
    click: function(event) {

      // Prevent default link functionality
      event.preventDefault();

      // Toggle the accordion
      block.toggle(this);

    },

    /**
     * Method to handle the keyboard input.
     *
     * @method block.keydown
     */
    keydown: function(event) {

      var key = event.which;

      // Get the active element
      var active = document.activeElement;

      // Switch logic based on key pressed
      switch(key) {

        // Handle on press of the enter/return key
        case config.keys.RETURN:

          // If a tab link has focus
          if (active.classList.contains("accordion-button")) {
            // Prevent default tabbing functionality
            event.preventDefault();
            // Toggle the accordion
            block.toggle(active);
          }

          break;

      }

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
